import { StudentProfile } from './student'
import { RecruiterProfile, Subscription } from './recruiter'

export enum UserRole {
  STUDENT = 'student',
  RECRUITER = 'recruiter',
  ADMIN = 'admin',
}

export interface BaseUser {
  id: string
  supabaseUserId: string
  email: string
  role: UserRole
  createdAt: Date
  updatedAt: Date
}

export interface Student extends BaseUser {
  role: UserRole.STUDENT
  profile?: StudentProfile
}

export interface Recruiter extends BaseUser {
  role: UserRole.RECRUITER
  profile?: RecruiterProfile
  subscription?: Subscription
}

export interface Admin extends BaseUser {
  role: UserRole.ADMIN
}

export type User = Student | Recruiter | Admin
